export default __webpack_public_path__ + "e6d679bc06070661ba1d45cc324d43f7.png";